import config from './config.json'
export const azureConfig = {
  /* authority: `https://bciepsddev.b2clogin.com/bciepsddev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=${config.authentication_policy}`, */
  authority: `https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=${config.authentication_policy}`,
  loadUserInfo: false,
  redirect_uri: `${config.redirect_uri}`,
  response_type: 'code',
  client_id: `${config.client_id}`,
  scope: 'openid',
  metadata: {
    issuer: `https://bciecambio2dev.b2clogin.com/219ff6e9-d538-43ca-a0ad-c880136b11fc/v2.0/`,
    authorization_endpoint: `https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/oauth2/v2.0/authorize?p=${config.authentication_policy}`,
    token_endpoint: `https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/oauth2/v2.0/token?p=${config.authentication_policy}`,
    jwks_uri: `https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/oauth2/v2.0/keys?p=${config.authentication_policy}`,
    end_session_endpoint: `https://bciecambio2dev.b2clogin.com/bciecambio2dev.onmicrosoft.com/oauth2/v2.0/logout?p=${config.authentication_policy}&post_logout_redirect_uri=${config.post_logout_redirect_uri}`,
  },
}